export class MarkSuggestionShownAction {
  static readonly type = '[Suggestion] Mark as shown';
  constructor(public studentId: number) {}
}
